export type SignatureRole = "driver" | "recipient";

export const SIGNATURE_ROLE_LABELS: Record<SignatureRole, string> = {
  driver: "Driver",
  recipient: "Recipient",
};

export type SignatureCaptureResult = {
  role: SignatureRole;
  dataUrl: string;
};
